<template>
    <div class="mx-auto w-full max-w-screen-2xl pt-0 pb-0 px-0">
        <grid-layout :layout.sync="layout"
                     v-if="layout.length"
                     :col-num="useSingleColumn?1:3"
                     :row-height="rowHeight"
                     :is-draggable="draggable"
                     :is-resizable="resizable"
                     :vertical-compact="true"
                     :is-bounded="false"
                     :use-css-transforms="useTransform"
                     @layout-updated="updateLayout"
                     class="bg-white gap-12"
        >
            <grid-item v-for="(item,index) in layout"
                       :key="item.i"
                       :x="item.x"
                       :y="item.y"
                       :w="item.w"
                       :h="item.h"
                       :i="item.i"
                       :is-resizable="resizable && ((item.maxW !== item.minW) || (item.maxH !== item.minH))"
                       :maxW="item.maxW"
                       :maxH="item.maxH"
                       :minW="item.minW"
                       :minH="item.minH"
                       @container-resized="resizeHandler"
                       :class="'p1 '+(useTransform?'':'no-transitions')"
            >
                <div class="border border-gray-200 rounded-xl bg-gray-100 p-3 pt-2 w-full h-full">
                    <component :is="item.component" v-if="item.component"
                               :dashboardData="$data" :dashboardProps="$props"
                    ></component>
                    <span class="text" v-else>{{ itemTitle(item) }}</span>
                </div>
                <span v-if="editmode" class="absolute right-2 top-2 cursor-pointer" @click="removeItem(index)"><i
                    class="text-gray-300 hover:text-brand fas fa-trash"></i></span>
            </grid-item>
        </grid-layout>
        <div class="w-full relative text-gray-500" :class="!layout.length?'mt-4':''" v-if="!useSingleColumn">
            <div class="absolute right-0 mr-2 border border-gray-200 rounded-xl bg-gray-50 h-12 w-12 text-center flex"
                 v-if="!editmode">
                <div class="flex-1">
                </div>
                <div class="flex-shrink-1 mr-2.5 hover:text-brand " @click="toggleEdit"><i
                    class="fas fa-cogs mt-3 text-xl"></i></div>
            </div>
            <div class="absolute right-0 mr-2 border border-gray-200 rounded-xl bg-gray-50 h-12 w-64 text-center flex"
                 v-else>
                <div class="flex-1 m-2">
                    <ui-dropdown menu-class="p-3 w-56">
                        <template #default="{ open,close,toggle }">
                            <div
                                class="bg-white rounded-lg border-gray-200 p-0.5 mt-0.5 border hover:text-brand text-sm font-semibold"
                                @click="toggle"><i class="fas fa-plus mr-3"></i>Add Widget
                            </div>
                        </template>
                        <template #menu="{ close }" class="relative">
                            <ui-dropdown-item v-for="(widgets,index) in groupedWidgets"
                                              :key="'widgetType'+index"
                                              :ref="'typeMenu'+widgets.type"
                                              @mouseleave="(e) => {$refs['typesubMenu'+widgets.type][0].close(e)}"
                                              @mouseenter="openTypeSubmenu(widgets.type)"
                                              :submenu="true"
                            >{{ widgets.group }}
                                <div class="fixed" style="width:auto;height:auto;overflow: visible"
                                     :ref="'typeMenu'+widgets.type+'relative'">
                                    <vue-context :ref="'typesubMenu'+widgets.type"
                                                 class="inline pb-0 focus:outline-none focus:ring-0 z-30"
                                                 :close-on-click="false" :close-on-scroll="false">
                                        <div class="p-3 w-64 z-30 bg-white rounded-lg border border-gray-300 shadow-lg">
                                            <ui-dropdown-item v-for="(widget,index) in widgets.items"
                                                              :icon="widget.icon"
                                                              :key="widget.type"
                                                              @click="addItem(widget.type)">
                                                {{ widget.name }}
                                            </ui-dropdown-item>
                                        </div>
                                    </vue-context>
                                </div>
                            </ui-dropdown-item>

                        </template>
                    </ui-dropdown>
                </div>
                <div class="flex-shrink-1 mr-2.5 hover:text-brand " @click="toggleEdit" v-if="!useSingleColumn"><i
                    class="fas fa-cogs mt-3 text-xl"></i></div>
            </div>
        </div>
    </div>
</template>

<script>
import {GridItem, GridLayout} from "vue-grid-layout"
import {Package, PackageNew} from '@models'
import UiDropdownItem from "../ui/UiDropdownItem.vue";
import {max} from "lodash";
import remoteStorage from "../../utils/remoteStorage";
import User from "../../services/User";
import Widgets from "./widgets";

export default {
    components: {
        UiDropdownItem,
        GridLayout,
        GridItem
    },
    props: {
        legacyPackage: Object,
        user: Object,
        googleKey: String,
        type: String
    },
    data() {
        return {
            widgets: Widgets.all(),
            userLayout: [],
            useTransform: false,
            legacyPackageItem: Package.make(this.legacyPackage),
            package: false,
            userItem: false,
            rowHeight: 150,
            useTransformTimeout: false,
            editmode: false,
            layout: [],
            useSingleColumn: false,
        }
    },
    computed: {
        draggable() {
            return this.editmode;
        },
        resizable() {
            return this.editmode;
        },
        groupedWidgets() {
            let groups = [];
            Object.keys(this.widgets).forEach((key) => {
                let w = this.widgets[key]
                w.type = key
                let type = w.group.toLowerCase();
                let g = groups.find((i) => i.type === type);
                if (!g) {
                    g = {group: w.group, type: type, items: []}
                    groups.push(g)
                }
                g.items.push(w)
            })
            return groups
        }
    },
    methods: {
        openTypeSubmenu(type) {
            this.$refs['typesubMenu' + type][0].open(new window.MouseEvent('mouse'))
            this.$nextTick(() => {
                this.$refs['typeMenu' + type + 'relative'][0].setAttribute('style', '')
                this.$nextTick(() => {
                    const opener = this.$refs['typeMenu' + type][0].$refs.submenu.getBoundingClientRect()
                    const box = this.$refs['typesubMenu' + type][0].$el.getBoundingClientRect()
                    let left = Math.min(opener.x - box.x - 10, window.innerWidth - (box.right) - 17);
                    let top = Math.min(opener.y - box.y - 10, window.innerHeight - (box.bottom) - 28);
                    this.$refs['typeMenu' + type + 'relative'][0].setAttribute('style', 'margin-left:' + left + 'px; margin-top:' + top + 'px')
                })
            })
        },
        setRowHeight() {
            this.disableTransform();
            let currentWidth = 1472
            if (this.$el) {
                let widthWithPaddings = this.$el.clientWidth;
                const elementComputedStyle = getComputedStyle(this.$el, null);
                currentWidth = (
                    widthWithPaddings -
                    parseFloat(elementComputedStyle.paddingLeft) -
                    parseFloat(elementComputedStyle.paddingRight)
                );
            }
            this.rowHeight = Math.max(120, ((currentWidth - (5 * 22)) / 3) / 3)
            this.enableTransform();
        },
        enableTransform() {
            this.useTransformTimeout = setTimeout(() => this.useTransform = true, 500)
        },
        disableTransform() {
            clearTimeout(this.useTransformTimeout)
            this.useTransform = false;
        },
        itemTitle(item) {
            let result = item.i;
            if (item.static) {
                result += " - Static";
            }
            return result;
        },
        toggleEdit() {
            this.editmode = !this.editmode
        },
        removeItem(index) {
            this.userLayout.splice(index, 1);
            this.buildLayout();
        },
        addItem(type) {
            let maxY = max(this.userLayout.map((item) => item.y + item.h))
            this.userLayout.push({
                "type": type,
                "x": 0,
                "y": maxY ? maxY : 0,
                "w": this.widgets[type].minW,
                "h": this.widgets[type].minH,
            });
            this.buildLayout();
        },
        updateLayout() {
            if (!this.useSingleColumn) {
                this.layout.forEach((l, k) => {
                    this.userLayout[k].x = l.x;
                    this.userLayout[k].y = l.y;
                    this.userLayout[k].w = l.w;
                    this.userLayout[k].h = l.h;
                })
                remoteStorage.setItem('dashboard-' + this.type, JSON.stringify(this.userLayout))
            }
        },
        buildLayout() {
            this.disableTransform();
            let ret = [];
            if (this.useSingleColumn) {
                let pos = 0;
                this.userLayout.toSorted((a, b) => ((a.y * 4) + a.x) - ((b.y * 4) + b.x)).forEach((l, k) => {
                    let type = l.type
                    ret.push({
                        "x": 0,
                        "y": pos,
                        "w": 1,
                        "h": l.h,
                        "maxW": 1,
                        "maxH": l.h,
                        "minW": 1,
                        "minH": l.h,
                        "i": k,
                        "component": type
                    })
                    pos += l.h;
                });
            } else {
                this.userLayout.forEach((l, k) => {
                    let type = l.type
                    ret.push({
                        "x": l.x,
                        "y": l.y,
                        "w": l.w,
                        "h": l.h,
                        "maxW": this.widgets[type].maxW,
                        "maxH": this.widgets[type].maxH,
                        "minW": this.widgets[type].minW,
                        "minH": this.widgets[type].minH,
                        "i": k,
                        "component": type
                    })
                });
            }
            this.layout = ret;
            this.$nextTick(() => {
                this.enableTransform();
            })
        },
        resizeHandler() {
            if ((this.$el.clientWidth < 900) && !this.useSingleColumn) {
                this.useSingleColumn = true;
                this.editmode = false;
                this.buildLayout();
                this.$forceUpdate();
            } else if ((this.$el.clientWidth > 900) && this.useSingleColumn) {
                this.useSingleColumn = false;
                this.buildLayout();
                this.$forceUpdate();
            }
            this.$nextTick(() => {
                this.setRowHeight()
            })
        }
    },
    async mounted() {
        await User.register()
        this.userItem = User.user
        this.package = await PackageNew.find(this.legacyPackageItem.reference)
        try {
            this.userLayout = remoteStorage.getItem('dashboard-' + this.type) ? JSON.parse(remoteStorage.getItem('dashboard-' + this.type)) : [
                {
                    "type": "package-map-widget",
                    "x": 0,
                    "y": 0,
                    "w": 2,
                    "h": 4,
                },
                {
                    "type": "package-notes-widget",
                    "x": 2,
                    "y": 0,
                    "w": 1,
                    "h": 6,
                },
                {
                    "type": "package-tasks-widget",
                    "x": 0,
                    "y": 2,
                    "w": 1,
                    "h": 2,
                },
                {
                    "type": "package-latest-progress-report-widget",
                    "x": 1,
                    "y": 2,
                    "w": 1,
                    "h": 1,
                },
            ]
        } catch (e) {
            //continue on JSON ERROR
        }
        this.resizeHandler();
        this.buildLayout();
        this.setRowHeight()

        window.addEventListener('resize', this.resizeHandler)
        this.$on('hook:beforeDestroy', () => {
            window.removeEventListener('resize', this.resizeHandler)
        })
        this.$emit('loaded')
    }
}
</script>

<style>
</style>

<style scoped>
.vue-grid-layout {
}

.no-transitions {
    transition-duration: 0ms !important;
}

.vue-grid-item:not(.vue-grid-placeholder) {
}

.vue-grid-item .resizing {
    opacity: 0.9;
}

.vue-grid-item .static {
    background: #cce;
}

.vue-grid-item .text {
    font-size: 24px;
    text-align: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    height: 100%;
    width: 100%;
}

.vue-grid-item .no-drag {
    height: 100%;
    width: 100%;
}

.vue-grid-item .minMax {
    font-size: 12px;
}

.vue-grid-item .add {
    cursor: pointer;
}

.vue-draggable-handle {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 0;
    left: 0;
    background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10'><circle cx='5' cy='5' r='5' fill='#999999'/></svg>") no-repeat;
    background-position: bottom right;
    padding: 0 8px 8px 0;
    background-repeat: no-repeat;
    background-origin: content-box;
    box-sizing: border-box;
    cursor: pointer;
}


</style>